import { Button, TextArea, Title } from '@qonsoll/react-design'
import { Form, Input } from 'antd'
import { KEYS, MAX_LENGTH_DESCRIPTION, MAX_LENGTH_FIELD } from '__constants__'

import { CountriesSelect } from 'domains/Country/components'
import { ImageUploader } from 'components'
import PropTypes from 'prop-types'
import { onTextAreaEnterPress } from 'helpers'
import { useTranslations } from 'contexts/Translation'

const NewspaperSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }

  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Newspaper')}
        </Title>
      )}
      <Form.Item
        label={t('Logo')}
        name={[...group, 'logoUrl']}
        rules={[
          {
            required: true,
            message: t('Please upload your newspaper logo!')
          }
        ]}>
        <ImageUploader />
      </Form.Item>
      <Form.Item
        label={t('Enter the name of newspaper you want too create below')}
        name={[...group, 'name']}
        rules={[
          {
            required: true,
            message: t('Please enter your newspaper name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('Newspaper name is too long!') }
        ]}>
        <Input placeholder={t('Newspaper name')} />
      </Form.Item>
      <Form.Item
        label={t('Enter the points criteria')}
        name={[...group, 'description']}
        rules={[
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('Points criteria is too long!')
          }
        ]}>
        <TextArea
          onPressEnter={onTextAreaEnterPress}
          placeholder={t('Points criteria')}
        />
      </Form.Item>
      <Form.Item
        label={'Select newspaper country'}
        name={[...group, 'countries']}
        rules={[
          {
            required: true,
            message: t('Please select newspaper countries!')
          }
        ]}>
        <CountriesSelect
          placeholder={t('Please select newspaper countries')}
          showSearch={true}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      onKeyPress={handleKeyPress}
      layout="vertical"
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Newspaper')}
        </Title>
      )}
      <Form.Item
        label={t('Logo')}
        name="logo"
        rules={[
          {
            required: true,
            message: t('Please upload your newspaper logo!')
          }
        ]}>
        <ImageUploader />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          {
            required: true,
            message: t('Please enter your newspaper name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('newspaper name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your newspaper name')} />
      </Form.Item>
      <Form.Item
        label={t('Description')}
        name={'description'}
        rules={[
          {
            max: MAX_LENGTH_FIELD,
            message: t('Newspaper description is too long!')
          }
        ]}>
        <TextArea
          onPressEnter={onTextAreaEnterPress}
          placeholder={t('Please enter your newspaper description')}
        />
      </Form.Item>

      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

NewspaperSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default NewspaperSimpleForm
